export enum ChartOfAccountsTemplateStartingPoint {
    default = "default",
    copyTemplate = "copyTemplate",
    copyEntity = "copyEntity",
    importCoa = "importCoa",
}
